/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/templated_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTemplatedPreview } from "./constants";
import { templatedPreviewUrl } from "./templatedPreviewUrl";
import type { PostTemplatedPreviewRequestProps, PostTemplatedPreviewServerResult } from "./types";

export const getEngagementAppGroupIdTemplatedPreview = reactQueryFetcherAdapter(
  engagementAppGroupIdTemplatedPreview,
  (
    signal: AbortSignal,
    { appGroupId, preview_source, ...templatedPreviewData }: PostTemplatedPreviewRequestProps
  ): Promise<PostTemplatedPreviewServerResult> => {
    return fetch(templatedPreviewUrl(appGroupId, preview_source), "POST", templatedPreviewData, { signal });
  },
  // this should be a validator but it is far too complex to vibe code
  () => true
);
